import { render } from "./CadastroPlanilhaTrechos.vue?vue&type=template&id=36e01990"
import script from "./CadastroPlanilhaTrechos.vue?vue&type=script&lang=ts"
export * from "./CadastroPlanilhaTrechos.vue?vue&type=script&lang=ts"
script.render = render

export default script